export const styles = (theme) => {
  return {
    DataGridFiltersContainer: {
      display: "flex",
      flexDirection: "row",
      flexWrap: "wrap",
      margin: "20px 0px 0px 0px",
      backgroundColor: `${theme.palette.custom.white}`,
      alignItems: "center",
      minWidth: "100%",
      borderRadius: "4px 4px 0px 0px",
      border: `1px solid ${theme.palette.custom.borderColor}`,
      borderBottom: "none",
    },

    DataGridFiltersSelect: {
      marginTop: "10px",
      marginBottom: "10px",
      width: "200px",
      "& .MuiSelect-select": {},
      "& .MuiOutlinedInput-notchedOutline": {
        color: `${theme.palette.custom.black}`,
        border: `1px solid ${theme.palette.custom.borderColor}`,
      },
      "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
        color: `${theme.palette.custom.black}`,
        border: `1px solid ${theme.palette.custom.borderColor}`,
      },
      "& .MuiInputLabel-root": {
        color: `${theme.palette.custom.black}`,
      },
    },

    DataGridFilterIcon: {
      width: "25px",
      height: "25x",
      marginRight: "15px",
      marginLeft: "15px",
    },

    DataGridFilterInputLabel: {
      color: `${theme.palette.custom.black}`,
      "&.Mui-focused": {
        color: `${theme.palette.custom.black}`,
      },
    },

    DataGridFilterFormControl: {
      display: "flex",
      marginLeft: "20px",
    },
  };
};
